import type { MediaType } from '@disy/lib/media-type';

import type { ExportActionOptions } from 'cadenza/actions/table/abstract-export-action-with-can-export-checked';
import { AbstractExportActionWithCanExportChecked } from 'cadenza/actions/table/abstract-export-action-with-can-export-checked';
import type { IndividualValuesTableDataExportOptions } from 'cadenza/api-client/workbook-export-data-api';
import {
  checkIfIndividualValuesTableCanBeExported,
  exportIndividualValuesTableData,
} from 'cadenza/api-client/workbook-export-data-api';
import type { WorkbookNameAndHash } from 'cadenza/repository/model/workbook-name-and-hash';
import type { ViewId } from 'cadenza/workbook/api/view-id';

export class AbstractIndividualValuesDrillThroughExportAction extends AbstractExportActionWithCanExportChecked {
  _viewId;
  _downloadParamsProvider;
  _workbookNameAndHash;

  constructor(
    workbookNameAndHash: WorkbookNameAndHash,
    viewId: ViewId,
    downloadParamsProvider: () => IndividualValuesTableDataExportOptions,
    mediaType: MediaType,
    options: ExportActionOptions,
  ) {
    super(mediaType, options);
    this._downloadParamsProvider = downloadParamsProvider;
    this._viewId = viewId;
    this._workbookNameAndHash = workbookNameAndHash;
  }

  override canExport() {
    return checkIfIndividualValuesTableCanBeExported(this._workbookNameAndHash, this._viewId, this.mediaType);
  }

  override startExport() {
    return exportIndividualValuesTableData(
      this._workbookNameAndHash,
      this._viewId,
      this.mediaType,
      this._downloadParamsProvider(),
    );
  }
}
